export const INIT_SERVER_STATE                = "INIT_SERVER_STATE";
export const PRODUCT_SEARCH_OPEN              = "PRODUCT_SEARCH_OPEN";
export const CHARTER_TIME_SELECTION_OPEN      = "CHARTER_TIME_SELECTION_OPEN";
export const ORIGIN_SEARCH_OPEN               = "ORIGIN_SEARCH_OPEN";
export const DESTINATION_SEARCH_OPEN          = "DESTINATION_SEARCH_OPEN";
export const DATE_SEARCH_OPEN                 = "DATE_SEARCH_OPEN";
export const ORIGIN_FILTER_OPEN               = "ORIGIN_FILTER_OPEN";
export const DESTINATION_FILTER_OPEN          = "DESTINATION_FILTER_OPEN";
export const ORIGIN_STATIONS_SELECTED         = "ORIGIN_STATIONS_SELECTED";
export const ORIGIN_STATIONS_FILTERED         = "ORIGIN_STATIONS_FILTERED";
export const DESTINATION_STATIONS_SELECTED    = "DESTINATION_STATIONS_SELECTED";
export const DESTINATION_STATIONS_FILTERED    = "DESTINATION_STATIONS_FILTERED";
export const SWAP_STATION_VALUES              = "SWAP_STATION_VALUES";
export const PASSENGER_QUANTITY_SELECTED      = "PASSENGER_QUANTITY_SELECTED";
export const TRAVEL_DATE_SELECTED             = "TRAVEL_DATE_SELECTED";
export const TRAVEL_TIME_RESET                = "TRAVEL_TIME_RESET";
export const TRAVEL_TIME_SELECTED             = "TRAVEL_TIME_SELECTED";
export const TRAVEL_TIME_VALIDATED            = "TRAVEL_TIME_VALIDATED";
export const CALENDAR_PARAMETERS_SUCCESS      = "CALENDAR_PARAMETERS_SUCCESS";
export const PRICE_DATE_LOADING               = "PRICE_DATE_LOADING";
export const PRICE_DATE_SUCCESS               = "PRICE_DATE_SUCCESS";
export const STATIONS_VALIDATED               = "STATIONS_VALIDATED";
export const STATIONS_VALIDATION_LOADING      = "STATIONS_VALIDATION_LOADING";
export const FLIGHT_ALERT_SET                 = "FLIGHT_ALERT_SET";
